module.exports = __webpack_public_path__ + "static/img/video1.e14fec2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index1/video1.png
// module id = gkkO
// module chunks = 7